import React, { useEffect, useState } from 'react';
import { Typography, TextField, Box, Button } from '@mui/material';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import { useNavigate } from 'react-router-dom';

import useGlobalState from '../hooks/useGlobalState';
import mainStyles from 'styles/mainStyles';
import OnboardContainer from 'components/OnboardContainer';
import { getDeviceByUuid, updateDevice } from 'data/api';
import CircularLoader from 'components/ui/CircularLoader';

const DeviceChooseName = () => {
	const classes = mainStyles();
	const [state, dispatch] = useGlobalState();
	const navigate = useNavigate();

	const [loading, setLoading] = useState(false);
	const [name, setName] = useState('');
	const [desc, setDesc] = useState('');

	useEffect(() => {
		if (!state.onboardedDevice) {
			navigate('/devices');
		}
	}, [state, navigate]);

	useEffect(() => {
		dispatch({ headerTitle: 'Navngiv enhed', showMobileStepper: false, showBottomNavigation: true });
	}, [dispatch]);

	useEffect(() => {
		setName(state.onboardedDevice.name);
		setDesc(state.onboardedDevice.description);
	}, [state.onboardedDevice]);

	const handleSave = async () => {
		setLoading(true);

		const deviceData = await getDeviceByUuid(state.onboardedDevice.uuid);

		if (deviceData) {
			let newDeviceData = { ...deviceData };
			newDeviceData.name = name;
			newDeviceData.description = desc;

			const deviceUpdateData = await updateDevice(newDeviceData);

			if (deviceUpdateData) {
				dispatch({ onboardedDevice: deviceUpdateData });

				navigate('/device');
			}
		}

		setLoading(false);
	}

	return (
		<OnboardContainer hasPadding={true} title={state.onboardedDevice.name} subtitle={state.onboardedDevice.uuname} icon={<DeviceHubIcon />} cancelRoute="/device">
			<Typography variant="h3" align="center">Enhed og beskrivelse</Typography>

			{!loading ?
				<>
					<TextField
						id="name"
						label="Navn"
						value={name}
						variant="outlined"
						color="secondary"
						className={classes.textField}
						onChange={(event) => setName(event.target.value)}
					/>

					<TextField
						multiline
						id="desc"
						label="Beskrivelse"
						value={desc}
						variant="outlined"
						color="secondary"
						className={classes.textField}
						onChange={(event) => setDesc(event.target.value)}
						inputProps={{
							style: {
								height: "200px",
							},
						}}
					/>

					<Box className={classes.buttonPanel} justifyContent="center">
						<Button className={classes.greenButton} onClick={() => handleSave()}>Gem</Button>
					</Box>
				</> : <CircularLoader />}
		</OnboardContainer>
	)
}

export default DeviceChooseName;